import React from 'react';
import { BarChart3Icon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function Results() {
  const caseStudies = [{
    client: 'TechSolutions Inc.',
    industry: 'SaaS',
    result: '187% increase in qualified leads',
    description: 'Implemented multi-channel lead generation strategy focusing on content marketing and LinkedIn outreach.',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80'
  }, {
    client: 'Global Finance Group',
    industry: 'Financial Services',
    result: '43% reduction in cost per lead',
    description: 'Optimized paid media campaigns and implemented marketing automation for lead nurturing.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2011&q=80'
  }, {
    client: 'HealthPlus',
    industry: 'Healthcare',
    result: '215% increase in conversion rate',
    description: 'Redesigned landing pages and implemented targeted email campaigns to engage high-value prospects.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80'
  }];
  const stats = [{
    label: 'Average Increase in Qualified Leads',
    value: '147%',
    icon: <UsersIcon className="h-8 w-8" data-id="element-249" />
  }, {
    label: 'Average Decrease in Cost Per Lead',
    value: '38%',
    icon: <TrendingUpIcon className="h-8 w-8" data-id="element-250" />
  }, {
    label: 'Average Increase in Conversion Rate',
    value: '83%',
    icon: <BarChart3Icon className="h-8 w-8" data-id="element-251" />
  }];
  return <section id="results" className="py-28 bg-gray-50 relative overflow-hidden" data-id="element-252">
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-1/3 h-1/3 bg-amber-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-253"></div>
      <div className="absolute bottom-20 left-0 w-1/4 h-1/4 bg-red-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-254"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="text-center mb-20" data-id="element-256">
          <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-257">
            Results
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-258">
            Real Results for Real Businesses
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-259">
            See how we've helped businesses like yours achieve significant
            improvements in their lead generation metrics.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-260">
          {stats.map((stat, index) => <div key={index} className="bg-gradient-to-br from-amber-400 to-red-400 rounded-2xl p-10 text-center text-white shadow-xl group hover:shadow-amber-500/20 transition-all duration-300 hover:translate-y-[-5px]" data-id="element-261">
              <div className="flex justify-center mb-6" data-id="element-262">
                <div className="bg-white/20 p-4 rounded-full transform transition-transform group-hover:scale-110 duration-300" data-id="element-263">
                  {stat.icon}
                </div>
              </div>
              <div className="text-5xl font-bold mb-4" data-id="element-264">{stat.value}</div>
              <div className="text-amber-50 font-medium" data-id="element-265">{stat.label}</div>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-266">
          {caseStudies.map((study, index) => <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:translate-y-[-5px] group" data-id="element-267">
              <div className="h-56 overflow-hidden" data-id="element-268">
                <img src={study.image} alt={study.client} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-269" />
              </div>
              <div className="p-8" data-id="element-270">
                <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-50 rounded-full mb-4" data-id="element-271">
                  {study.industry}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-272">
                  {study.client}
                </h3>
                <div className="text-lg font-semibold text-amber-600 mb-4" data-id="element-273">
                  {study.result}
                </div>
                <p className="text-gray-600" data-id="element-274">{study.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-24 text-center" data-id="element-275">
          <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-white bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 transition-all duration-300 hover:shadow-amber-500/20" data-id="element-276">
            Get Similar Results
          </a>
        </div>
      </div>
    </section>;
}